module.exports = __webpack_public_path__ + "img/ddwu_gallery11.0dc46728.jpg";